<template>
	<LayoutTableCommonRow>
		<LayoutTableCommonPartText :text="period.name" :header="header" :subtext="subtext" />
		<LayoutTableCommonPartMenu>
			<template #options>
				<router-link :to="{ name: 'company.admin.goal.period.form', params: { id: period.goal_id, goal_period_id: period.id }}" class="dropdown-item rounded-0" v-if="!period.processed">Editar</router-link>
				<a href="javascript:void(0)" class="dropdown-item rounded-0" @click="remove">Eliminar</a>
				<template v-if="period.processed">
					<div class="dropdown-divider"></div>
					<div class="dropdown-item-text py-1 rounded-0 lh-xs text-danger">No puedes modificar este período porque ya se encuentra procesado.</div>
				</template>
			</template>
		</LayoutTableCommonPartMenu>
	</LayoutTableCommonRow>
</template>

<script>
	import { computed } from 'vue';
	import _ from 'lodash';
	import moment from 'moment';

	export default {
		emits: ['remove'],
		props: {
			period: Object
		},
		setup(props, { emit }) {
			const remove = () => emit('remove', props.period);

			const header = computed(() => {
				let status = null,
					data = null;

				if(props.period.processed) status = '<span class="text-success"><i class="bi bi-check-lg"></i> Procesado</span>';
				else status = '<span><i class="bi bi-clock-history"></i> Sin procesar</span>';
				
				if(props.period.users_count == 0) data = `Sin vendedores cargados`;
				else if(props.period.users_count == 1) data = `1 vendedor cargado`;
				else data = `${props.period.users_count} vendedores cargados`;

				return `${status} - ${data}`;
			});

			const subtext = computed(() => {
				let start_date = moment(props.period.start_date).format('DD/MM/YYYY'),
					end_date = moment(props.period.end_date).format('DD/MM/YYYY'),
					diff = moment(props.period.end_date).diff(moment(props.period.start_date), 'days') + 1;

				return `${start_date} - ${end_date} (${diff} ${(diff == 1) ? 'día' : 'días'})`;
			});

			return { remove, header, subtext };
		}
	}
</script>